import { Badge as AntBadge, Tabs as AntTabs } from 'antd';

export interface TabSpec { id: string; label: string; count?: number }

/** Ant Tabs with the previous {tabs, activeId, onChange} contract; counts render as small badges. */
export function Tabs({ tabs, activeId, onChange }: { tabs: TabSpec[]; activeId: string; onChange: (id: string) => void }) {
  return (
    <AntTabs
      className="tab-bar"
      activeKey={activeId}
      onChange={onChange}
      items={tabs.map((t) => ({
        key: t.id,
        label: t.count !== undefined ? <span>{t.label} <AntBadge count={t.count} showZero size="small" color="#07843D" style={{ marginLeft: 4 }} /></span> : t.label,
      }))}
    />
  );
}
